import React, { Component } from 'react';
import './../css/Actividad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { faHome, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from 'react-bootstrap-table-next';
import { ReactComponent as EditarIcon } from './../../img//svg/Editar.svg';
import { ReactComponent as EliminarIcon } from './../../img//svg/Eliminar.svg';
import enviar from './../../img/svg/Enviar(blanco).svg';
import Swal from 'sweetalert2'
 
export class Solicitud_materia extends Component {
    static displayName = Solicitud_materia.name;

    constructor(props) {
        super(props);
        this.state = {
            materias: [], materia: {
                idcurso: 0, porc: 0, anio: "", term: "", termino: "", codigomateria: "", nommateria: "", numhorasteoricas: 0, numhoraspracticas: 0, paralelo: 0, idtipoactividad: 0,
                observacion: "", fechaInicio: "", fechaFin: "", valorevaluacion: 0, valornumexam: 0, estadocheck: "", tipoprofesor: ""
            },  observacion: "", pao1: "", pao2: "", pae: "", accion: "", loading: false, loading2: false
        };
        this.onInputChange = this.onInputChange.bind(this); 
        this.agregarSolicitud = this.agregarSolicitud.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.onChangeRadioAcciones = this.onChangeRadioAcciones.bind(this);
    }

    componentDidMount() {
    }
    //funcion para click en update delete
    handleClick = (text) => {
        this.setState({
            accion: text,
        });
    }
    onChangeValue(event) { 
        this.setState({
            accion: event.target.value,
        });
    }

    // funcion para los radio buttons de update delete
    onChangeRadioAcciones(text) {
        //console.log("onChangeRadioAcciones: ", text);
        this.setState({
            accion: text,
        });
    }

    onInputChange(event) {
        var control = event.target.name;
        if (control === "review") {
            var value = this.state.observacion;
            value = event.target.value.toUpperCase();
            this.setState({
                observacion: value
            });
        } 
        //this.props.updatestate_mat(this.props.idcurso, this.state.observacion, this.state.termino, this.state.accion)
    }
     
    agregarSolicitud(event) { 
        event.preventDefault();
        if (this.state.observacion != "" && this.state.accion != "") {

            this.props.updatestate(this.props.rowIndex, this.props.idcurso,
                this.props.descripcion, this.state.observacion,
                this.props.anio, this.props.termino, this.props.totalhoras,
                this.state.accion, this.props.idUnico)

            this.props.closeExpandxId(this.props.idcurso)

            Swal.fire({
                title: 'Hecho!',
                text: 'Asignatura agregada exitosamente',
                icon: 'success',
                timer: 1500,
                confirmButtonText: 'Ok'
            })
        } else {

            Swal.fire({
                title: 'ERROR!',
                text: 'Debes llenar los campos observación y escoger acción',
                icon: 'error',
                timer: 1500,
                confirmButtonText: 'Ok'
            })
        }


    }
    handlkeyPress(evento) {
        // console.log(String.fromCharCode(event.keyCode));
        let tecla = evento.which;
        let caracter = String.fromCharCode(tecla)
        let regex = new RegExp("^[A-Za-z0-9 ,.]+$");


        if (!regex.test(caracter)) {

            Swal.fire({
                title: 'Lo sentimos!',
                text: 'El campo de observación no permite caracteres especiales.',
                icon: 'error',
                timer: 1500,
                confirmButtonText: 'Ok'
            })

            return false;
        }

    }

    render() {

        const estilo = {
            color: 'white',
            fontSize: '10px',
        };


        return (
            <div>
                <div className="box2 sb9"><table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead>
                        <tr className='tr-tablexpand-header'>
                            <th className='tr-descr-header'></th>
                            <th className='tr-perio-header'></th>
                            <th className='tr-obser-header'></th>
                            <th className='tr-perio-header'></th>
                            <th className='tr-accio-header'></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td className='td-descr-header'>Asignatura</td>
                            <td className='td-perio-header'>Paralelo</td>
                            <td className='td-obser-header'>Observación <label className="asterisco">*</label></td>
                            <td className='td-perio-header'>Periodo</td>
                            <td className='td-accio-header'>Acciones <label className="asterisco">*</label></td>
                        </tr>
                        <tr>
                            <td>{this.props.descripcion}</td>
                            <td>
                                {this.props.paralelo}
                            </td>
                            <td><textarea id="review" name="review" onKeyPress={this.handlkeyPress}  className='area_width' value={this.state.observacion} onChange={this.onInputChange}></textarea></td>
                            <td>
                                {this.props.termino}
                            </td>
                            <td> 

                                <div> {/*onChange={this.onChangeValue}*/}

                                    <ul id="list" className="list-group pb-4">
                                        <li className="list-group-item d-flex justify-content-between align-items-center"> {/*onClick={() => this.handleClick("Modificar Carga")}*/}
                                            <input className="form-check-input" type="radio" name="radiosAccion" id="radioModificar" value="0" onChange={() => { this.onChangeRadioAcciones("Modificar Carga") }} />Modificar

                                        {/*<FontAwesomeIcon icon={faEdit} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Modificar Carga")} title="Modificar Carga" style={this.state.accion === "Modificar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />Modificar*/}
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center"> {/*onClick={() => this.handleClick("Eliminar Carga")}*/}
                                            <input className="form-check-input" type="radio" name="radiosAccion" id="radioEliminar" value="1" onChange={() => { this.onChangeRadioAcciones("Eliminar Carga") }} />Eliminar

                                            {/*<FontAwesomeIcon icon={faTrash} className="icon-cursor" name="accion" onChange={this.onChangeValue} onClick={() => this.handleClick("Eliminar Carga")} title="Eliminar Carga" style={this.state.accion === "Eliminar Carga" ? { color: '#ffdb00' } : { color: '#58A7E0' }} size="2x" />Eliminar*/}
                                        </li>
                                    </ul>


                                </div>
                               

                                <div>
                                    <button type="button" className="btn btn-sm btn-info btn-agregar" onClick={this.agregarSolicitud}>    {/* funcion para guardar la solicitud y enviar a la unificada*/}
                                        <img width="24px" height="24px" src={enviar} />Agregar Observación</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table></div>

            </div>
        );
    }

}